@import '../../theme/global';

snap-mobile-picker {
  box-sizing: border-box;
  @include set-font;

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    list-style: none;
  }

  /* date */
  .snap-mobile-picker {
    align-items: stretch;
    display: flex;
    height: 235px;
    justify-content: space-between;
    width: 160px;

    &.right-aligned {
      .highlight-list,
      .select-options {
        text-align: right;
      }

      .snap-mobile-picker-container .select-options .select-option {
        left: initial;
        right: 10px;
      }

      .highlight {
        border-radius: 8px 0 0 8px;
      }

      .highlight-list .highlight-item {
        padding-right: 10px;
      }
    }

    &.left-aligned {
      .highlight-list,
      .select-options {
        text-align: left;
      }

      .snap-mobile-picker-container .select-options .select-option {
        left: 10px;
      }

      .highlight {
        border-radius: 0 8px 8px 0;
      }

      .highlight-list .highlight-item {
        padding-left: 10px;
      }
    }

    & > div {
      flex: 1;
    }

  }

  .snap-mobile-picker-container {
    color: #ddd;
    font-size: 18px;
    height: 100%;
    overflow: hidden;
    position: relative;
    text-align: center;

    &::before, &::after {
      content: "";
      display: block;
      height: 50%;
      position: absolute;
      width: 100%;
      z-index: 1;
    }

    &::before {
      background-image: linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(1, 1, 1, 0));
      top: 0;
    }

    &::after {
      background-image: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(1, 1, 1, 0));
      bottom: 0;
    }

    .select-options {
      color: $gray-400;
      display: block;
      -webkit-font-smoothing: subpixel-antialiased;
      font-weight: 500;
      height: 0;
      left: 0;
      margin: 0 auto;
      position: absolute;
      top: 50%;
      transform: translateZ(-150px) rotateX(0deg);
      transform-style: preserve-3d;
      width: 100%;

      .select-option {
        -webkit-font-smoothing: subpixel-antialiased;
        height: 50px;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;

        @for $i from 1 through 200 {
          &:nth-child(#{$i}) {
            transform: rotateX(-18deg * ($i - 1)) translateZ(150px);
          }
        }
      }
    }

    .highlight {
      background-color: $blue-100;
      color: $gray-800;
      font-size: 20px;
      font-weight: 500;
      overflow: hidden;
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      width: 100%;
    }

    .highlight-list {
      position: absolute;
      width: 100%;
    }
  }
}

